<template>
  <a-modal
    title="新建事中风控"
    :width="1080"
    :visible="visible"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24" v-if="model !== null && model['id'] === undefined">
            <a-divider orientation="left">
              风控信息
            </a-divider>
          </a-col>
          <a-col :span="24" v-if="model !== null && model['id'] === undefined">
            <a-form-item label="系统编号">
              <a-input v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" />
            </a-form-item>
            <a-form-item label="采销全流程">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                v-decorator="[
                  'project_id',
                  {
                    rules: [
                      { required: true, message: '选择' },
                    ],
                  },
                ]"
                placeholder="请输入名称"
                @search="this.projectSearch"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              风险提示
            </a-divider>
          </a-col>
          <a-col :offset="2" :span="22">
            <div>
              <a-button icon="plus" @click="handleAddAttachment()">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.attachment"
                :columns="attachmentColumns"
                v-if="this.otherData.attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="url" slot-scope="urls">
                  <a-row>
                    <a-col :span="24" v-for="text in urls" :key="text">
                      <a :href="text" target="_blank"> {{ text }}</a>
                    </a-col>
                  </a-row>
                </template>
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(1, record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
    <attachment-create-form
      ref="attachmentCreateForm"
      @cancel="handleAddCancel"
      @ok="handleOk"
      :record="mdl"
      :visible="visibleFrom"
      v-if="visibleFrom"
      :loading="confirmLoading"
      :model="mdl" />
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'
import AttachmentCreateForm from '../attachment/modules/CreateForm'

// 表单字段
const fields = ['id', 'number', 'name', 'cash']
export default {
  components: {
    AttachmentCreateForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      projectFetching: false,
      projectList: [],
      form: this.$form.createForm(this),
      visibleFrom: false,
      confirmLoading: false,
      mdl: undefined,
      otherData: {
        attachment: []
      },
      attachmentColumns: [
        {
          title: '风险提示名称',
          ellipsis: true,
          dataIndex: 'risk_warning_title'
        },
        {
          title: '风险提示内容',
          ellipsis: true,
          dataIndex: 'risk_warning_content'
        },
        {
          title: '附件',
          ellipsis: true,
          dataIndex: 'url',
          scopedSlots: { customRender: 'url' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  methods: {
    handleProjectSearch (value) {
      this.projectFetching = true
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    onAttachmentDelete (type, key) {
      if (type === 1) {
        const dataSource = [...this.otherData.attachment]
        this.otherData.attachment = dataSource.filter(item => item.key !== key)
      } else if (type === 2) {
        const dataSource = [...this.otherData.invoice_attachment]
        this.otherData.invoice_attachment = dataSource.filter(item => item.key !== key)
      }
    },
    handleAddAttachment () {
      this.mdl = undefined
      this.visibleFrom = true
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs.attachmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (date) {
      const form = this.$refs.attachmentCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          // 新增
          if (values.url) {
            values.url = values.url.fileList.map(item => item.url)
          }
          const current_date = new Date()
          values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
          this.otherData.attachment.push(values)
          this.visibleFrom = false
          form.resetFields()
        }
      })
    },
    ok () {
      if (this.otherData.attachment.length === 0) {
        this.$message.warning('添加风险提示')
        return
      }
      const data = { items: undefined }
      if (this.otherData.attachment) {
        data.items = this.otherData.attachment.map(item => {
          item.key = undefined
          return item
        })
      }
      this.$emit('ok', data)
    }
  }
}
</script>
